<div>
  <app-generic-chart
    [data]="data"
    [presentationType]="presentationType"
    [chartConfiguration]="chartConfiguration" />
</div>
